<template>
  <div>
    <multiselect
        v-model="multiselectValue"
        :options="elementSettings.data"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :placeholder="elementSettings.placeholder || 'Select'"
        :label="elementSettings.label || 'text'"
        :track-by="elementSettings.trackBy || 'value'"
        :disabled="elementSettings.disabled"
        :hideSelected="true"
        :hideNoOptions="true"
        :showLabels="false"
    />
    <div class="text-error-notification" v-if="isError && typeof elementSettings.errorMessage === 'string' && elementSettings.isValidated">{{elementSettings.errorMessage}}</div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'ElementMultiselect',
  components: {
    Multiselect
  },
  props: {
    elementSettings: {
      required: true,
      type: Object
    },
    formSettings: {
      required: true,
      type: Object
    }
  },
  computed: {
    multiselectValue: {
      get () {
        return this.elementSettings.value || []
      },
      set (value) {
        this.elementSettings.value = value
      }
    },
    isError: {
      cache: false,
      get () {
        this.elementSettings.isError = !this.validate(this.elementSettings, this.formSettings)
        return this.elementSettings.isError
      }
    }
  },
  methods: {
    executeElementValidate () {
      this.elementSettings.isError = !this.validate(this.elementSettings, this.formSettings)
    }
  }
}
</script>

<style lang="scss">
@import "../../../@core/scss/vue/libs/vue-multiselect.scss";

// Dark layout overrides
.dark-layout {
  .multiselect__tags {
    border-color: rgba(82, 90, 114, 0.57);
  }
  .multiselect__single {
    color: #dddddd !important;
  }
  .multiselect__tags-wrap {
    color: white;
  }
}
</style>